import { memo } from 'react';
import isEqual from 'react-fast-compare';

import { CatalogGrid } from '@/components/CatalogCard/CatalogGrid';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import { PAGE_ITEMS_TO_VIEW } from '@/components/Pagination/helpers/filterSortOptions';

type Props = {
    catalogIds?: number[];
    changePageAndNavigate: Function;
    changePageSizeAndNavigate: Function;
    page: number;
    pageSize: number;
    totalItemsFound: number;
    trackUpcomingCatalogClick?: (id: number) => void;
};

const AuctionCalendarResultsComponent = (props: Props) => {
    const { catalogIds, changePageAndNavigate, changePageSizeAndNavigate, page, pageSize, totalItemsFound } = props;

    const onChange = ({ page, pageSize }) => {
        if (!pageSize) {
            changePageAndNavigate(page - 1);
        } else {
            changePageSizeAndNavigate(pageSize);
        }
    };

    return (
        <div className="relative max-w-full flex-1">
            <Pagination
                onChange={onChange}
                pageSizeOptions={PAGE_ITEMS_TO_VIEW}
                paginationFilter={{
                    page,
                    pageSize,
                    totalRecords: totalItemsFound,
                }}
                restrictPagesTo={10}
            >
                <CatalogGrid
                    catalogIds={catalogIds}
                    className="mx-[-10px] min-h-[360px] w-[calc(100%+20px)] max-w-[calc(100%+20px)] flex-[1_0_auto]"
                />
            </Pagination>
        </div>
    );
};

export const AuctionCalendarResults = memo<Props>(AuctionCalendarResultsComponent, isEqual);
